import { createAction, props } from '@ngrx/store';
import { DataSource } from '@sharedModule/models/data-source.model';
import { ConversionRateInterface } from '../types/currency-conversion-rate';
import { ConversionRateFilter } from '../types/currency-conversion-rate-filter';

export const fetchConversionRate = createAction(
  '[Conversion Rate List] Conversion Rate List Fetch',
  props<{ filter?: ConversionRateFilter }>()
);

export const updateConversionRateFilter = createAction(
  '[Conversion Rate Filter] Conversion Rate List update filter',
  props<{ filter?: ConversionRateFilter }>()
);

export const loadedConversionRate = createAction(
  '[Conversion Rate List] Conversion Rate List Loaded',
  props<{ dataSource: DataSource<ConversionRateInterface[]> }>()
);

export const failedConversionRate = createAction(
  '[Conversion Rate List] Conversion Rate List Failed'
);

export const deleteVelocityLimit = createAction(
  '[Conversion Rate List] Delete Conversion Rate',
  props<{ id: number }>()
);

export const resetConversionRate = createAction(
  '[Conversion Rate List] Reset Conversion Rate List'
);
